import React, { useState } from 'react';
import axios from 'axios';
import LogoutButton from './LogoutButton';

const ProductForm = () => {
    const [productId, setProductId] = useState(''); // State for Product_ID input
    const [product, setProduct] = useState(null); // State for product details
    const [quantity, setQuantity] = useState(''); // State for product quantity
    const [mode, setMode] = useState('IN'); // Mode: IN or OUT
    const [errorMessage, setErrorMessage] = useState(''); // State for error messages

    // Fetch product data by Product_ID and update quantity
    const handleScan = async () => {
        try {
            setErrorMessage(''); // Reset the error message
            const response = await axios.get('https://st.tjdstore.in/api/productedit.php', {
                params: { product_id: productId }, // Send Product_ID as a parameter
            });

            if (response.data.error) {
                setErrorMessage(response.data.error); // Show backend error
                setProduct(null);
                return;
            }

            const fetchedProduct = response.data;
            const currentQuantity = parseInt(fetchedProduct.Product_Quantity, 10);
            const newQuantity = mode === 'IN' ? currentQuantity + 1 : Math.max(0, currentQuantity - 1);

            // Update quantity in backend
            await axios.post('https://st.tjdstore.in/api/productedit.php', {
                product_id: productId,
                quantity: newQuantity,
            });

            // Update UI
            setProduct(fetchedProduct);
            setQuantity(newQuantity);
        } catch (error) {
            console.error('Error handling scan:', error);
            setErrorMessage('Failed to process the Product_ID!');
        }
    };

    return (
        <div>
            <h3>Stock Manager</h3>
            <LogoutButton />

            {/* Mode Selection */}
            <div className="col-md-3 mb-3">
                <label>Select Mode: </label>
                <select
                    className="form-control"
                    value={mode}
                    onChange={(e) => setMode(e.target.value)}
                    style={{
                        backgroundColor: mode === 'IN' ? '#198754' : '#DC3545',
                        color: 'white',
                        fontWeight: 'bold',
                    }}
                >
                    <option
                        value="IN"
                        style={{ backgroundColor: '#198754', color: 'white', fontWeight: 'bold' }}
                    >
                        Product IN
                    </option>
                    <option
                        value="OUT"
                        style={{ backgroundColor: '#DC3545', color: 'white', fontWeight: 'bold' }}
                    >
                        Product OUT
                    </option>
                </select>
            </div>

            {/* Product_ID Input */}
            <div className="col-md-3">
                <label>Enter Product_ID: </label>
                <input
                    className="form-control"
                    placeholder="Enter Product_ID..."
                    type="text"
                    value={productId}
                    onChange={(e) => setProductId(e.target.value)} // Update Product_ID state
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            handleScan(); // Trigger action on Enter key
                            setProductId(''); // Clear Product_ID input
                        }
                    }}
                />
            </div>

            {/* Error Message */}
            {errorMessage && (
                <div className="col-md-6 alert alert-danger mt-3">
                    <strong>Error: </strong>{errorMessage}
                </div>
            )}

            {/* Product Details */}
            {product && (
                <div className="col-md-6 mt-3">
                    <h4>{product.Product_Name}</h4>
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td>Product_ID:</td>
                                <td>{product.Product_ID}</td>
                            </tr>
                            <tr>
                                <td>SKU:</td>
                                <td>{product.Product_SKU}</td>
                            </tr>
                            <tr>
                                <td>Size:</td>
                                <td>{product.Product_Size}</td>
                            </tr>
                            <tr>
                                <td>Product Category:</td>
                                <td>{product.Product_Type}</td>
                            </tr>
                            <tr>
                                <td>Quantity:</td>
                                <td>{quantity}</td>
                            </tr>
                        </tbody>
                    </table>
                    <img
                        src={product.Product_Img}
                        alt={product.Product_Name}
                        style={{ width: '200px', height: 'auto' }}
                    />
                </div>
            )}
        </div>
    );
};

export default ProductForm;
